module.exports = __webpack_public_path__ + "media/images/social-youtube-cc2d444fd44c8224eeb9e2e3bd1e01b6.svg";